<p>score-registration-landing works!</p>
